import component from './component.js';
import './styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  const componentNodes = Array.from(document.querySelectorAll('[data-schedule-calendar="component"]'));

  return componentNodes.map((componentNode) => {
    const { preventInit } = componentNode.dataset;

    if (preventInit) {
      return false;
    }

    return component(componentNode);
  });
});

export default component;
